<template>
    <div>
        <div class="row justify-content-center px-5">
            <div class="col-12 text-center px-5 px-sm-0">
                <div class="card text-left mb-4 mt-3 gray-border no-shadow border-2 radius-8">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2 text-right"><b-icon icon="exclamation-triangle" style="width: 90px; height: 90px; max-width: 100%;" variant="danger" class="align-custom"></b-icon></div>
                            <div class="col-md-10 d-flex justify-content-center flex-column">
                                <h5 class="mb-2 text-danger">Disclaimer</h5>
                                <p class="mb-0 text-secondary">This is <b>not</b> applicable for manual payrun, any file uploaded here for manual payrun will be disregarded.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <a :href="'/employees/variable-data/import/'+current_month+'/'+current_fiscal_year+'?department_ids='+department+'&work_location_ids='+work_location" class="btn btn-primary btn-download mb-4 mt-2 mx-2"><i class="fa fa-download" aria-hidden="true"></i> Download Variable Data Template</a>
                <a :href="'/employees/overtime-data/import/'+current_month+'/'+current_fiscal_year+'?department_ids='+department+'&work_location_ids='+work_location" class="btn btn-primary btn-download mb-4 mt-2 mx-2"><i class="fa fa-download" aria-hidden="true"></i> Download Overtime Data Template</a>
                <br>
                <button type="button" class="btn btn-primary btn-download mb-4 mt-2 mx-2 d-flex flex-column align-items-center" :disabled="mihcmImporting" @click="importFromMihcm" v-if="is_expo == 1">
                    <span><i class="fa fa-cloud-download" aria-hidden="true"></i> Import Variable Data from MiHCM</span>
                    <b-spinner small v-if="mihcmImporting" class="mt-1"></b-spinner>
                </button>

                <div class="card text-center mb-4 mt-3 gray-border no-shadow border-2 radius-8 px-5">
                    <div class="card-body text-secondary">
                        <p class="mb-5">Please download the Variable Data Template and populate employee variable payments into the template and upload accordingly.</p>
                        <h5 class="font-medium">We will process the payrun including this data as applicable.</h5>

                        <b-overlay :show="showoverlay" rounded="sm" class="mt-4 px-5 text-left">
                            <label class="mt-4 w-100 text-left">Upload variable data template</label>
                            <b-form-file id="variable_datafile" name="variable_datafile" class="mt-2" @change="uploadFile" placeholder="Choose a file..." accept=".xlsx,.xls"></b-form-file>
                            <label class="mt-4 w-100 text-left">Upload overtime data template</label>
                            <b-form-file id="datafile_overtime" name="datafile_overtime" class="mt-2" @change="uploadFileOvertime" placeholder="Choose a file..." accept=".xlsx,.xls"></b-form-file>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="mihcm-missing-heads-modal" dialog-class="modal-xl" size="xl" scrollable hide-footer title="Missing Pay Items Found">
            <b-overlay rounded="sm">
                <template v-if="mihcmMissingRows.length > 0">
                    <p class="text-secondary text-left mb-2 font-semi-bold">Missing — no field with this name exists in AccordHRM:</p>
                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <th scope="col">Sheet</th>
                                <th scope="col">PayItem</th>
                                <th scope="col">PayItemType</th>
                                <th scope="col">Gross Component</th>
                                <th scope="col">Transaction Type</th>
                                <th scope="col">Tax Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="display: none;"></tr>
                            <tr class="table-row hover-bg" v-for="(row, index) in mihcmMissingRows" :key="'missing-'+index">
                                <td>{{row.Sheet}}</td>
                                <td>{{row.PayItem}}</td>
                                <td>{{row.PayItemType}}</td>
                                <td>{{row['Gross Component']}}</td>
                                <td>{{row['Transaction Type']}}</td>
                                <td>{{row['Tax Type']}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <template v-if="mihcmTypeMismatchRows.length > 0">
                    <p class="text-secondary text-left mb-2 mt-4 font-semi-bold">Type Mismatch — field exists in AccordHRM but under a different type/taxability:</p>
                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <th scope="col">Sheet</th>
                                <th scope="col">PayItem</th>
                                <th scope="col">PayItemType</th>
                                <th scope="col">Gross Component</th>
                                <th scope="col">Transaction Type</th>
                                <th scope="col">Tax Type</th>
                                <th scope="col">Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="display: none;"></tr>
                            <tr class="table-row hover-bg" v-for="(row, index) in mihcmTypeMismatchRows" :key="'mismatch-'+index">
                                <td>{{row.Sheet}}</td>
                                <td>{{row.PayItem}}</td>
                                <td>{{row.PayItemType}}</td>
                                <td>{{row['Gross Component']}}</td>
                                <td>{{row['Transaction Type']}}</td>
                                <td>{{row['Tax Type']}}</td>
                                <td>{{row.Detail}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <div class="text-right mt-3">
                    <b-button class="mr-2" @click="cancelMihcmImport()">Cancel</b-button>
                    <b-button class="btn btn-primary btn-download mr-2" @click="downloadMihcmMissingHeadsExcel()"><i class="fa fa-download" aria-hidden="true"></i> Download</b-button>
                    <b-button variant="danger" @click="proceedMihcmImport()">Proceed Anyway</b-button>
                </div>
            </b-overlay>
        </b-modal>
  </div>
</template>
<script>

    export default{

        mounted() {

        },
        props: ['current_fiscal_year','current_month', 'department', 'work_location' ],
        data(){

            return {

                ce : true,
                empfile : null,
                showoverlay : false,
                mihcmImporting : false,
                mihcmMissingRows : [],
                mihcmTypeMismatchRows : [],
                is_expo: 0,
            }
        },
        methods:{
            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                this.showoverlay = true;
                this.empfile = event.target.files[0];
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);
                data.append('fiscal_year', this.current_fiscal_year);
                data.append('month', this.current_month);

                axios.post('/employees/variable-data/import', data , config).
                    then(function (response){

                        this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        this.showoverlay = false;

                    }.bind(this)).
                    catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed numeric value encountered.' , {
                                                title: `Data Template Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    });
            },
            uploadFileOvertime:function(event)
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                this.showoverlay = true;
                this.empfile = event.target.files[0];
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);
                data.append('fiscal_year', this.current_fiscal_year);
                data.append('month', this.current_month);

                axios.post('/employees/overtime-data/import', data , config).
                    then(function (response){

                        this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        this.showoverlay = false;

                    }.bind(this)).
                    catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed numeric value encountered.' , {
                                                title: `Data Template Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    });
            },
            importFromMihcm:function()
            {
                if(!this.checkNet()) return false;

                this.runMihcmImport(false);
            },
            runMihcmImport:function(confirmed)
            {
                let currentObj = this;
                this.mihcmImporting = true;

                const params = {
                    month: this.current_month,
                    fiscal_year: this.current_fiscal_year,
                    department_ids: this.department,
                    work_location_ids: this.work_location,
                };

                if (confirmed) {
                    params.confirm = 1;
                }

                axios.post(
                    '/employees/variable-data/import-from-mihcm',
                    params
                ).
                    then(function (response)
                    {
                        const data = response.data;

                        if (data && data.requires_confirmation) {
                            currentObj.mihcmImporting = false;
                            currentObj.confirmMihcmMissingHeads(data);
                            return;
                        }

                        currentObj.mihcmImporting = false;
                        currentObj.$bvToast.toast('Variable data imported from MiHCM successfully', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                    }).
                    catch(function (error)
                    {
                        currentObj.mihcmImporting = false;
                        currentObj.$bvToast.toast('Failed to import variable data from MiHCM. Please try again or contact support.' , {
                                                title: `Import Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    });
            },
            confirmMihcmMissingHeads:function(data)
            {
                this.mihcmMissingRows = [];
                this.mihcmTypeMismatchRows = [];

                const missingHeads = data.missing_heads || {};
                Object.keys(missingHeads).forEach(function (sheetName) {
                    (missingHeads[sheetName] || []).forEach(function (item) {
                        const row = {
                            Sheet: sheetName,
                            PayItem: item.PayItem,
                            PayItemType: item.PayItemType,
                            'Gross Component': item['Gross Component'],
                            'Transaction Type': item['Transaction Type'],
                            'Tax Type': item['Tax Type'],
                            Detail: item.Detail,
                        };

                        if (item.Status === 'Type mismatch') {
                            this.mihcmTypeMismatchRows.push(row);
                        } else {
                            this.mihcmMissingRows.push(row);
                        }
                    }.bind(this));
                }.bind(this));

                this.$bvModal.show('mihcm-missing-heads-modal');
            },
            proceedMihcmImport:function()
            {
                this.$bvModal.hide('mihcm-missing-heads-modal');
                this.runMihcmImport(true);
            },
            cancelMihcmImport:function()
            {
                this.$bvModal.hide('mihcm-missing-heads-modal');
            },

            downloadMihcmMissingHeadsExcel:function()
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                this.mihcmDownloadingReport = true;

                const config = {
                    responseType: 'blob',
                }

                axios.get('/mihcm/missing-heads-report', config).then(function (response)
                {
                    currentObj.mihcmDownloadingReport = false;

                    if(response.data.type == 'application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            currentObj.$bvToast.toast(err_obj.message, {title: 'Error', variant: 'danger', solid: true});
                        });
                    }else{
                        currentObj.global_download_file_content(response);
                    }

                }).catch(function (error){ currentObj.mihcmDownloadingReport = false; currentObj.serverError(error); });
            },

            getAgentId:function()
            {
                let currentObj = this;
            
                axios.get('/get-agent-id').
                    then(function (response){
            
                        currentObj.is_expo = response.data.data.is_expo;
            
                    }).
                    catch(function (error)
                    {
                        currentObj.$bvToast.toast('Failed to load agent info. Please try again.', {
                                                title: `Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    });
            },

        },

        created: function(){
            this.getAgentId();

        },
    }
</script>